export const QUERY_KEYS = {
  attachments: 'item_attachments',
};
